import React from 'react';
import _TopProductTab from './_TopProductTab.scss';
import {TopProductList} from './TopProduct';
import {withRouter} from 'react-router-dom';

class TopProductTab extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <section className="highlight-top-product-tab">
        <TopProductList/>
      </section>
    );
  }
}

export default withRouter(TopProductTab);



// WEBPACK FOOTER //
// ./components/home/sub-view/TopProductTab.jsx